export default __webpack_public_path__ + "static/food-cutting-logo-d0e51873a7d2db7733721ba169462a70.svg";